import React, {Fragment} from "react";
import NsDataTable from "../../../../components/tabelle/NsDataTable";
import {getTimestampFormattato} from "../../../../utility/common";
import TabellaKpiController from "./TabellaKpiController";
import Translate from "../../../../components/Translate";

export default function StoricoModificheKpiView({
                                                    modificheKpi,
                                                    modificaSel,
                                                    setModificaSel,
                                                    modifichePresenti,
                                                    strutturaKpi,
                                                    translate,
                                                    formikRef,
                                            }) {

    return (
        <Fragment>
            <div className={"row mb-4"}>
                <div className={"col-md-12"}>
                    <NsDataTable
                        data={modificheKpi}
                        columns={[
                            {
                                name: translate('Data modifica'),
                                selector: row => getTimestampFormattato(row.data, true),
                                sortable: true,
                            },
                            {
                                name: translate('Utente modifica'),
                                selector: row => row.utenteModifica,
                                sortable: true,
                            },
                            {
                                name: translate('Azione'),
                                selector: row => <span>{translate(row.azione)}&nbsp;<strong>{translate(row.stato) || ''}</strong></span>,
                                sortable: true,
                            },
                            {
                                name: '',
                                selector: row => row.tipo === 'M' &&
                                    <button
                                        type={"button"}
                                        className={"btn btn-dark"}
                                        onClick={() => {
                                            setModificaSel(row.id_storico_mod_kpi);
                                        }}
                                    >
                                        <span className="far fa-eye" />
                                    </button>
                                ,
                                sortable: false,
                                right: true,
                            },
                        ]}
                    />
                </div>
            </div>

            {
                modificaSel && strutturaKpi &&
                <div className={"row mt-4"}>
                    <div className={"col-md-12"}>
                        {
                            (modifichePresenti || modificaSel === modificheKpi[modificheKpi.length -1].id_storico_mod_kpi) ?
                            <TabellaKpiController
                                tabella={strutturaKpi}
                                modifica={false}
                                formikRef={formikRef}
                            />
                            : <h5><Translate>Nessuna modifica presente</Translate></h5>
                        }
                    </div>
                </div>
            }
        </Fragment>
    );
}